export class Events {
    localizationChanged(onLocalizationChange) {
        window.unify.onLocalizationChange = onLocalizationChange;
    }
}